import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { offerInfoSortingFunc } from '../utils/offerUtils';
export const reducePromotionsResponse = data => {
  if (data && data.productsEligibleForDirectPromotions) {
    const offersMap = Object.keys(data.offersById).reduce((acc, offerId) => {
      const {
        commitmentTerm,
        paymentTerm,
        discount
      } = data.offersById[offerId];
      return Object.assign({}, acc, {
        [offerId]: {
          commitment: commitmentTerm.toLowerCase(),
          payment: paymentTerm.toLowerCase(),
          discount
        }
      });
    }, {});
    const getSortedOfferIds = (offerIds = []) => offerIds.sort((firstOfferId, secondOfferId) => {
      return offerInfoSortingFunc(offersMap[firstOfferId] || null, offersMap[secondOfferId] || null);
    });
    const crmSuiteOfferIds = Object.keys(data.crmSuiteOfferIds || {}).reduce((suiteOffersObj, keyName) => {
      var _data$crmSuiteOfferId, _data$crmSuiteOfferId2;
      const keyMap = {
        starterOfferIds: STARTER,
        professionalOfferIds: PROFESSIONAL,
        enterpriseOfferIds: ENTERPRISE
      };
      const {
        productOfferIds,
        quantityPackOfferIdsBySkuUuid,
        seatsOfferIds
      } = (_data$crmSuiteOfferId = (_data$crmSuiteOfferId2 = data.crmSuiteOfferIds) === null || _data$crmSuiteOfferId2 === void 0 ? void 0 : _data$crmSuiteOfferId2[keyName]) !== null && _data$crmSuiteOfferId !== void 0 ? _data$crmSuiteOfferId : {};
      const sortedProductOfferIds = getSortedOfferIds(productOfferIds);
      const sortedSeatOfferIds = getSortedOfferIds(seatsOfferIds);
      const sortedQuantityPackOfferIds = Object.keys(quantityPackOfferIdsBySkuUuid || {}).reduce((sortedObj, apiName) => {
        const sortedOfferIds = Object.keys(quantityPackOfferIdsBySkuUuid[apiName]).reduce((sortedOffers, skuUuid) => Object.assign({}, sortedOffers, {
          [skuUuid]: getSortedOfferIds(quantityPackOfferIdsBySkuUuid[apiName][skuUuid])
        }), {});
        return Object.assign({}, sortedObj, {
          [apiName]: sortedOfferIds
        });
      }, {});
      return Object.assign({}, suiteOffersObj, {
        [keyMap[keyName]]: {
          productOfferIds: sortedProductOfferIds,
          quantityPackOfferIdsBySkuUuid: sortedQuantityPackOfferIds,
          seatsOfferIds: sortedSeatOfferIds
        }
      });
    }, {});
    return Object.assign({}, data, {
      offersById: offersMap,
      crmSuiteOfferIds
    });
  }
  return data;
};